// extracted by mini-css-extract-plugin
export default {"container":"_65ruqXOyUUKH7FRSxSOfjM"};